import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Sell,buy} from '../actions/blockCahinFunc';
import Alert from './Layout/Alert';

const Client_Total_Capital = ({
  balance: { balance,contractBalance },
  Sell,
  buy,
  load: { web3, contract, account,networkId },
}) => {
  const [amountEth1, setEth1] = useState(undefined);
  const [amountEth2, setEth2] = useState(undefined);

  
  const onSubmit1 = e => {
    e.preventDefault();
    buy(web3, contract, account, amountEth1);
  };
  
  const onSubmit2 = e => {
    e.preventDefault();
    Sell(web3, contract, account, amountEth2);
  };

  return (
    <Fragment>
      <nav className='navbar'>
        <h4
          style={{
            textAlign: 'center',
            fontSize: '40px',
            color: 'whitesmoke',
            fontWeight: 'bolder',
            fontFamily: 'fantasy',
          }}
        >
          NEOK Token
        </h4>
      </nav>
      <Alert />
      <div className='grid'>
        <article className='card product-item'>
          <form onSubmit={e => onSubmit1(e)}>
            <header className='card__header'>
              <h1 className='contant'>Buy Neok Token</h1>
              <h1 className='product__title'>1 ETH = 20000NEK</h1>
              {
                networkId !== 1 ? ( <h1 className='product__title'>
                Please Connect to Rinkeby test network and reload the page
              </h1>):null
            }
            </header>
            <div className='card__content'>
              <h1 className='product__title'>
              Supply
              </h1>
              <h1 className='product__title'>{balance} NEK</h1>
              <h2 className='product__price'>
                <label className='custom-field'>
                  <input
                    className='input'
                    type='number'
                    min='0.00001'
                    value={amountEth1}
                    onChange={e => setEth1(e.target.value)}
                    max='10'
                    step='0.00001'
                    placeholder='Total ETH to swap'
                  />
                </label>
              </h2>
              <h2 className='product__price'>
                <label className='custom-field'>
                  <input
                    className='input'
                    type='number'
                    min='0'
                    value={amountEth1 * 20000}
                    max='100'
                    step='0.00001'
                    readOnly
                    placeholder='Total NEK tokens you will get'
                  ></input>
                </label>
              </h2>
            </div>
            <div className='card__actions'>
              <button className='btn' type='submit'>
                BUY
              </button>
            </div>
          </form>
        </article>

        <article className='card product-item'>
          <form onSubmit={e => onSubmit2(e)}>
            <header className='card__header'>
              <h1 className='contant'>Treasury Rate</h1>
              <h1 className='product__title'>1 NEK = 0.000010 ETH</h1>

            </header>
            <div className='card__content'>
              <h1 className='product__title'>Wallet Balance</h1>
              <h1 className='product__title'>{contractBalance} ETH</h1>
              <h2 className='product__price'>
                <label className='custom-field'>
                  <input
                    className='input'
                    type='number'
                    min='0.01'
                    value={amountEth2}
                    onChange={e => setEth2(e.target.value)}
                    max='100000'
                    step='0.01'
                    placeholder='NEK Tokens you will sell'
                  ></input>
                </label>
              </h2>
              <h2 className='product__price'>
                <label className='custom-field'>
                  <input
                    className='input'
                    type='number'
                    min='0'
                    value={parseFloat(amountEth2 * 0.000010)}
                    max='100'
                    step='0.0001'
                    readOnly
                    placeholder='Total ETH'
                  ></input>
                </label>
              </h2>
            </div>
            <div className='card__actions'>
              <button className='btn' type='submit'>
                Sell
              </button>
            </div>
          </form>
        </article>
      </div>
    </Fragment>
);
};

Client_Total_Capital.propTypes = {
  load: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  balance: state.balance,
  load: state.load,
});

export default connect(mapStateToProps, { Sell,buy })(Client_Total_Capital);

/*
 <article className='card product-item'>
          <form onSubmit={e => onSubmit2(e)}>
            <header className='card__header'>
              <h1 className='contant'>Treasury Rate</h1>
              <h1 className='product__title'>is 1 SMA = 0.002 ETH</h1>
            </header>
            <div className='card__content'>
              <h1 className='product__title'>Treasury balance</h1>
              <h1 className='product__title'>{contractBalance} ETH</h1>
              <h2 className='product__price'>
                <label className='custom-field'>
                  <input
                    className='input'
                    type='number'
                    min='0.01'
                    value={ammountToken}
                    onChange={e => setAmountToken(e.target.value)}
                    max='10000'
                    step='0.01'
                    placeholder='SMA Tokens you will sell'
                  ></input>
                </label>
              </h2>
              <h2 className='product__price'>
                <label className='custom-field'>
                  <input
                    className='input'
                    type='number'
                    min='0'
                    value={ammountToken * 0.002}
                    max='100'
                    step='0.0001'
                    readOnly
                    placeholder='Total ETH'
                  ></input>
                </label>
              </h2>
            </div>
            <div className='card__actions'>
              <button className='btn2' type='submit'>
                SELL
              </button>
            </div>
          </form>
        </article>
*/
